module.exports = __webpack_public_path__ + "img/master-current-language.0c9d421b.svg";